import { EXECUTION_STATUS } from '../hooks/useReplayExecution';
import { isRecordingSkipMarkerStep } from './replayEligibility';

const TRACKED_REPLAY_STATUSES = new Set([
    EXECUTION_STATUS.IN_PROGRESS,
    EXECUTION_STATUS.PASSED,
    EXECUTION_STATUS.FAILED,
    EXECUTION_STATUS.SKIPPED,
]);

/**
 * Resolve replay row status from progress map + plan step recording markers.
 * Only recording-failed steps are pre-marked Skipped; pending steps stay Pending until replay runs.
 */
export function resolveReplayStepStatus(
    step,
    flatIndex,
    replayProgressMap = {},
    isReplayFlow = false,
    instructions = null,
    options = {}
) {
    const { ignoreProgressForPendingCustomStep = false } = options;
    const fromMap = replayProgressMap?.[flatIndex];

    // Custom steps keep status: 'pending' on the plan object — always trust replay progress
    // keyed to the current step id (live, terminal, and in-progress).
    if (fromMap && fromMap !== EXECUTION_STATUS.NEW && TRACKED_REPLAY_STATUSES.has(fromMap)) {
        return fromMap;
    }

    if (ignoreProgressForPendingCustomStep && step?.customStep === true && step?.status === 'pending') {
        return EXECUTION_STATUS.PENDING;
    }
    if (isReplayFlow && isRecordingSkipMarkerStep(step, instructions)) {
        return EXECUTION_STATUS.SKIPPED;
    }
    return fromMap ?? EXECUTION_STATUS.PENDING;
}

/**
 * Count steps that will be or were skipped in replay (recording pending/failed + post-failure cascade).
 */
export function countSkippedReplaySteps(replayProgressMap = {}) {
    if (!replayProgressMap || typeof replayProgressMap !== 'object') return 0;
    return Object.values(replayProgressMap).filter((s) => s === EXECUTION_STATUS.SKIPPED).length;
}
